import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import { RootRedirect } from './RootRedirect';
import { RouteFallback } from '@/components/shared/RouteFallback';

/**
 * A0-FE tomonidan qo'yilgan statik ildiz yo'llar (domenga tegishli emas).
 * Boshqa agentlar bu faylga tegmaydi — OWNERSHIP.md, frontend/src/router/** muzlatilgan.
 *
 * BUG-001 (BUGS.md) qo'shimcha topilma (2026-08-31): `__dev/design-system` — faqat
 * diagnostika uchun ishlatiladigan sahifa — bu yerda STATIK import qilingani sababli
 * `@/components/shared` barrel orqali Leaflet (`MapPicker` ichida) va uning CSS'i
 * PRODUCTION asosiy chunkka (barcha foydalanuvchi uchun) tushib qolgan edi. Lazy qilib
 * ajratildi — endi faqat shu sahifaga kirilganda yuklanadi.
 */
const DesignSystemPage = lazy(() =>
  import('@/pages/__dev/DesignSystem').then((m) => ({ default: m.DesignSystemPage })),
);

export const rootRoutes: RouteObject[] = [
  { path: '/', element: <RootRedirect /> },
  {
    path: '/__dev/design-system',
    element: (
      <Suspense fallback={<RouteFallback />}>
        <DesignSystemPage />
      </Suspense>
    ),
  },
];
